import { unsubscribe } from "pubsub-js";
import { useLayoutEffect } from "react";

import { subscribeEvent } from "./subscribeEvent.ts";
import type { Callback, EventMessage } from "./types.ts";

export const useEventSubscribe = <TCallback extends Callback<any>>(event: EventMessage, callback: TCallback) => {
  // not sure why useLayoutEffect is needed over useEffect. Doesn't work otherwise
  useLayoutEffect(() => {
    const token = subscribeEvent(event, callback);
    return () => {
      unsubscribe(token);
    };
  }, [event, callback]);
};
